import React, { Component } from 'react';
import { bool, func, object, shape } from 'prop-types';
import { withRouter } from 'react-router';
import { hideSlideout, showSlideout } from 'ps-components/Slideout/SlideoutReducer';
import { connect } from 'react-redux';
import { SLIDEOUTS as MarketPaySlideouts } from '../Slideout/Slideouts';
import { SLIDEOUTS as CommonSlideouts } from 'ps-components/Slideout/Slideouts';

/**
 * This class is intended to listen to the slideout reducer and add a hash to the URL
 * when the slideout is shown and remove the hash from the URL when the slideout is hidden
 */
class SlideoutRouter extends Component {
  static propTypes = {
    location: object.isRequired,
    history: object.isRequired,
    showSlideout: func.isRequired,
    hideSlideout: func.isRequired,
    slideout: shape({
      open: bool,
      slideoutType: object,
      slideoutProps: object
    })
  };

  SLIDEOUTS = { ...MarketPaySlideouts, ...CommonSlideouts };
  SLIDEOUT_KEYS = Object.keys(this.SLIDEOUTS);
  SLIDEOUT_HASHES = this.SLIDEOUT_KEYS.map(key => this.SLIDEOUTS[key].hash);
  SLIDEOUT_PATHS = this.SLIDEOUT_KEYS.map(key => this.SLIDEOUTS[key].path);

  /**
   * Open slideout if hash exists on page refresh
   */
  componentDidMount() {
    const { showSlideout, location } = this.props;

    const lastPath = this.getLastPath();

    if (location.hash && this.SLIDEOUT_HASHES.includes(location.hash)) {
      for (let i = 0; i < this.SLIDEOUT_KEYS.length; i++) {
        const slideoutKey = this.SLIDEOUT_KEYS[i];
        if (this.SLIDEOUTS[slideoutKey].hash === location.hash) {
          showSlideout(this.SLIDEOUTS[slideoutKey]);
          break;
        }
      }
    } else if (lastPath && this.SLIDEOUT_PATHS.includes(lastPath)) {
      for (let i = 0; i < this.SLIDEOUT_KEYS.length; i++) {
        const slideoutKey = this.SLIDEOUT_KEYS[i];
        if (this.SLIDEOUTS[slideoutKey].path === lastPath) {
          showSlideout(this.SLIDEOUTS[slideoutKey]);
          break;
        }
      }
    }
  }

  /**
   * On component update (props / state change), apply navigation based on if slideout properties have changed
   */
  componentDidUpdate() {
    this.applyNavigation();
  }

  shouldComponentUpdate = nextProps => {
    const { slideout } = this.props;
    const slideoutChange =
      slideout &&
      (slideout.open !== nextProps.slideout.open || slideout.slideoutType !== nextProps.slideout.slideoutType);

    return slideoutChange;
  };

  removeSlideoutLocation = () => {
    const { location } = this.props;
    const lastPath = this.getLastPath();

    if (lastPath && this.SLIDEOUT_PATHS.includes(lastPath)) {
      const newUrl = location.pathname.replace(`/${lastPath}`, '');
      this.props.history.push(newUrl, location.state);
    } else {
      const newUrl = location.pathname + location.search;
      this.props.history.push(newUrl, location.state);
      // push new page view to mouseflow
      if (window._mfq) {
        window._mfq.push(['newPageView', newUrl]);
      }
    }
  };

  /**
   * Add or remove hash based on open or close of slideout
   */
  applyNavigation = () => {
    const { slideout } = this.props;
    const { open, slideoutType } = slideout;
    open ? this.addSlideoutLocation(slideoutType) : this.removeSlideoutLocation();
  };

  addSlideoutLocation() {
    const { history, location, slideout } = this.props;
    if (slideout.slideoutType) {
      if (!this.isIframePage() && slideout.slideoutType.path) {
        if (this.getLastPath() !== slideout.slideoutType.path) {
          const newUrl = `${location.pathname}/${slideout.slideoutType.path}${location.search}`;
          history.push(newUrl, location.state);
        }
      } else if (slideout.slideoutType.hash) {
        const newUrl = location.pathname + location.search + slideout.slideoutType.hash;
        history.push(newUrl, location.state);
        // push new page view to mouseflow
        if (window._mfq) {
          window._mfq.push(['newPageView', newUrl]);
        }
      }
    }
  }

  isIframePage() {
    const { location } = this.props;
    return location.pathname.indexOf('/iframe') !== -1;
  }

  getLastPath() {
    const { location } = this.props;
    return location.pathname.substring(location.pathname.lastIndexOf('/') + 1);
  }

  render() {
    return null;
  }
}

const mapStateToProps = ({ slideout }) => {
  return {
    slideout
  };
};

export default withRouter(
  connect(mapStateToProps, {
    showSlideout,
    hideSlideout
  })(SlideoutRouter)
);
